<template>
	<a-config-provider :locale="locale">
		<div id="app" :style="globalFontStyle">
			<router-view />
			<div class="goods-new" v-if="newsShow" @click="handleCloseModal">
				<img :src="url" alt="">
			</div>
		</div>
	</a-config-provider>
</template>

<script>
	import themeColor from '@/components/SettingDrawer/themeColor.js'

	import {
		domTitle,
		setDocumentTitle
	} from '@/utils/domUtil'
	import {
		i18nRender
	} from '@/locales'
	import {
		planAdd,
	} from '@/api/public.js';
	import bus from '@/utils/bus'
	import {
		savePerformanceDraft
	} from '@/utils/performanceDraft'
	// import './qiankun'
	export default {
		data() {
			return {
				url: '',
				newsShow: false,
				timer: null,
				// 全局字体大小
				baseFontSize: 12,
				// data[0]==='6' 新数据提醒通知 key，用于一键清理
				type6NoticeKeys: []
			}
		},

		computed: {
			locale() {
				return this.$i18n.getLocaleMessage(this.$store.getters.lang).antLocale
			},
			// 绑定全局字体样式
			globalFontStyle() {
				return {
					'font-size': this.baseFontSize + 'px'
				}
			}
		},
		watch: {
			'$route.meta.title'(title) {
				if (title) {
					setDocumentTitle(`${i18nRender(title)} - ${domTitle}`)
				}
			}
		},
		created() {
			themeColor.initTheme()
			const metaTitle = this.$route && this.$route.meta && this.$route.meta.title
			if (metaTitle) {
				setDocumentTitle(`${i18nRender(metaTitle)} - ${domTitle}`)
			}
			this.$ws.createWebSocket(localStorage.getItem('userId'));
			window.addEventListener("wsMessage", (e) => {
				console.log("收到后端推送：", e);
				let data = e.detail.split('|$|');
				console.log(data);
				clearInterval(this.timer)
				// 3-喜报，4-备忘提醒 
				if (data[0] === '3') {
					// 这是喜报消息
					this.newsShow = true;
					let displayNum = data[2] || 7000
					this.url = data[1];
					this.timer = setInterval(() => {
						this.handleCloseModal()
					}, displayNum)
				}
				if (data[0] === '4') {
					// 备忘提醒
					// let str = '4|$|提醒内容|303'
					this.$confirm({
						content: data[1].split('|')[0],
						cancelText: '随后处理',
						okText: '处理',
						onOk: () => {
							console.log('跳转详情')
							this.closeOpenModalsBeforeJump()
							this.$nextTick(() => {
								this.handleOpenPage(data[1].split('|')[1], 5, [])
							})
						},
						onCancel: () => {
							// 取消逻辑
							planAdd({
								minNum: 20,
								customerId: data[1].split('|')[1]
							}).then(res => {
								console.log('添加备忘时间', res);
								if (res.code == '20001') {}
							})
						}
					});
				}
				if (data[0] === '5') {
					// "5|$|一部主管对金嘉乐用户线索点评"
					console.log('点评提醒')
					this.$confirm({
						content: data[1].split('|')[0],
						cancelText: '关闭',
						okText: '去处理',
						onOk: () => {
							console.log('跳转详情')
							this.closeOpenModalsBeforeJump()
							this.$nextTick(() => {
								this.handleJumpDetail(data[2], 5, {}, this.getUserName(data[1]), '')
							})
						},
					});
				}
				if (data[0] === '6') {
					this.refreshMenuBadgeCount()
					const noticeKey = `type6_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`
					this.type6NoticeKeys.push(noticeKey)
					this.$notification.open({
						key: noticeKey,
						message: `新数据提醒`,
						description: '你有一条新数据分配，请及时处理',
						placement: 'bottomRight',
						duration: 0, // 核心：0 = 永久显示
						btn: h => {
							return h(
								'div', {
									style: {
										display: 'inline-flex',
										alignItems: 'center'
									}
								},
								[
									h(
										'a-button', {
											props: {
												size: 'small',
											},
											style: {
												marginRight: '8px'
											},
											on: {
												click: () => this.clearType6Notifications(),
											},
										},
										'清理全部',
									),
									h(
										'a-button', {
											props: {
												type: 'primary',
												size: 'small',
											},
											on: {
												click: () => {
													this.$notification.close(noticeKey)
													this.type6NoticeKeys = this.type6NoticeKeys.filter(k => k !== noticeKey)
													// 正在填写新增业绩时，先缓存表单再跳转处理新数据
													this.cachePerformanceDraftIfNeeded()
													this.closeOpenModalsBeforeJump()
													this.$nextTick(() => {
														this.handleJumpDetail(data[1], 5, {}, this.getUserName(data[1]), '')
													})
												},
											},
										},
										'去处理',
									),
								]
							);
						},
					});
				}
				if (data[0] === '7') {
					// 通知加载菜单角标
					this.refreshMenuBadgeCount()
				}
				if(data[0] === '8'){
					this.refreshMenuBadgeCount()
					this.$notification.open({
						key: noticeKey,
						message: `新数据提醒`,
						description: '新数据未分配成功，请手动分配',
						placement: 'bottomRight',
					});
				}
			});
			// 初始化字体
			this.resizeFont()
			// 监听窗口大小
			window.addEventListener('resize', this.resizeFont)
		},
		beforeDestroy() {
			// 页面销毁时断开Socket
			this.$ws.closeWebSocket();
			window.removeEventListener('resize', this.resizeFont)
		},
		methods: {
			handleCloseModal() {
				this.newsShow = false;
				clearInterval(this.timer)
			},
			// 清理全部 data[0]==='6' 创建的通知弹窗
			clearType6Notifications() {
				const keys = this.type6NoticeKeys || []
				keys.forEach(key => {
					this.$notification.close(key)
				})
				this.type6NoticeKeys = []
			},
			/** 查找正在新增业绩的弹窗组件 */
			findAddCasesVm(vm) {
				if (!vm) {
					return null
				}
				try {
					if (vm.$options && vm.$options.name === 'AddCases' && vm.visible && vm.showType === 'add') {
						return vm
					}
				} catch (e) {}
				const children = vm.$children || []
				for (let i = 0; i < children.length; i++) {
					const found = this.findAddCasesVm(children[i])
					if (found) {
						return found
					}
				}
				return null
			},
			/** 去处理新数据前：若正在填写新增业绩，先缓存表单内容 */
			cachePerformanceDraftIfNeeded() {
				try {
					const addCases = this.findAddCasesVm(this.$root)
					if (addCases && typeof addCases.getDraftSnapshot === 'function') {
						const snapshot = addCases.getDraftSnapshot()
						if (snapshot) {
							savePerformanceDraft(snapshot)
						}
					}
				} catch (e) {
					console.warn('缓存业绩草稿失败', e)
				}
			},
			/**
			 * 提醒跳转详情前关闭当前业务弹窗（如电子合同新增等），避免遮挡详情页
			 * 注意：不要 Modal.destroyAll，会误毁当前确认框并可能打断跳转
			 */
			closeOpenModalsBeforeJump() {
				try {
					bus.$emit('closeAllBusinessModals')
				} catch (e) {}
				this.closeVisibleModalsInTree(this.$root)
			},
			closeVisibleModalsInTree(vm) {
				if (!vm) {
					return
				}
				try {
					const hasVisible = vm.$data && Object.prototype.hasOwnProperty.call(vm.$data, 'visible')
					// 只关带关闭方法的业务弹窗，避免误改其它 visible 状态
					if (hasVisible && vm.visible === true) {
						if (typeof vm.handleClose === 'function') {
							vm.handleClose()
						} else if (typeof vm.closeModal === 'function') {
							vm.closeModal()
						}
					}
				} catch (e) {}
				const children = vm.$children || []
				for (let i = 0; i < children.length; i++) {
					this.closeVisibleModalsInTree(children[i])
				}
			},
			// 14寸笔记本 动态字体适配
			resizeFont() {
				const width = document.documentElement.clientWidth
				// 14寸笔记本主流宽度：1200 ~ 1919
				if (width >= 1920) {
					this.baseFontSize = 15
				} else if (width >= 1200) {
					this.baseFontSize = 12 // 14寸笔记本专用
				} else {
					this.baseFontSize = 10
				}
			}
		}
	}
</script>

<style lang="less">
	@font-face {
		font-family: "iconfont";
		/* Project id 5124786 */
		src: url('//at.alicdn.com/t/c/font_5124786_o6b1nptvdl.woff2?t=1770451244135') format('woff2'),
			url('//at.alicdn.com/t/c/font_5124786_o6b1nptvdl.woff?t=1770451244135') format('woff'),
			url('//at.alicdn.com/t/c/font_5124786_o6b1nptvdl.ttf?t=1770451244135') format('truetype');
	}

	.iconfont {
		font-family: "iconfont" !important;
		font-size: 16px;
		font-style: normal;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
	}

	* {
		margin: 0;
		padding: 0;
		border-radius: 0;
		/* 继承全局字体 */
		font-size: inherit;
	}

	.content {
		// height: calc(100vh - 41px) !important;
		background: #fff;
	}

	/* ========== 3. 表格（标题 + 内容 全部统一） ========== */
	.ant-table-thead>tr>th,
	.ant-table-tbody>tr>td,
	.ant-table {
		font-size: inherit !important;
	}

	/* ========== 4. 表单 / 卡片 / 弹窗 / 标签 ========== */
	.ant-form label,
	.ant-card,
	.ant-modal-body,
	.ant-tag,
	.ant-breadcrumb {
		font-size: inherit !important;
	}


	.ant-input,
	.ant-select-selector,
	.ant-btn,
	.ant-upload,
	.ant-radio-button-wrapper,
	.ant-input-search,
	.ant-select-selection,
	.ant-input-group-addon,
	.ant-tag {
		border-radius: 4px !important;
	}

	.ant-radio-wrapper,
	.ant-checkbox-wrapper,
	.ant-select-item,
	.ant-select-selection-item,
	.ant-radio-group,
	.ant-checkbox-group {
		font-size: inherit !important;
	}

	// 按钮式单选/多选
	.ant-radio-button-wrapper {
		font-size: inherit !important;
	}

	.ant-radio-button-wrapper {
		border-radius: 0 !important;
		text-align: center;
		min-width: 40px !important;
		padding: 0 5px !important;
	}


	// 下拉弹窗里的选项（很关键，经常漏这个）
	:root .ant-select-dropdown .ant-select-item {
		font-size: inherit !important;
	}

	/* 表单项容器（若表单有圆角也可覆盖） */
	.ant-form-item-control-input-content {
		border-radius: 8px;
	}

	/* 弹窗、卡片等容器类组件（如果需要也可以统一） */
	.ant-modal-content,
	.ant-card {
		border-radius: 8px !important;
	}

	/*
	 * 浮层层级说明（ant-design-vue 默认）：
	 * Modal ≈ 1000，Select/DatePicker/TreeSelect 下拉 ≈ 1050
	 * 勿全局抬高 Modal，否则弹窗内下拉会被挡住（看起来像“没数据”）
	 * 退出登录等特殊确认框可在调用处单独传 zIndex
	 * 弹窗内下拉若挂到 body，保证高于 Modal
	 */
	.ant-select-dropdown,
	.ant-cascader-menus,
	.ant-calendar-picker-container,
	.ant-time-picker-panel,
	.ant-dropdown,
	.ant-popover,
	.ant-tooltip {
		z-index: 1100 !important;
	}

	.ant-form-item {
		margin-bottom: 14px !important;
	}

	.ant-table-middle>.ant-table-content>.ant-table-scroll>.ant-table-body>table>.ant-table-tbody>tr>td {
		padding: 4px !important;
	}

	.ant-table-thead>tr>th,
	.ant-table-tbody>tr>td {
		padding: 4px 2px !important;
	}

	.ant-pro-basicLayout-content .ant-pro-page-header-wrap {
		margin: 0 !important;
	}

	.ant-pro-page-header-wrap-children-content {
		margin-top: 0 !important;
	}

	.el-table .el-table__cell {
		padding: 5px 0 !important;
	}

	.ant-layout-footer {
		padding: 10px 50px !important;
	}

	.goods-new {
		width: calc(100% - 256px);
		height: 100vh;
		position: fixed;
		top: 0;
		right: 0;
		background: rgba(0, 0, 0, 0.5);
	}

	.goods-new img {
		position: absolute;
		width: 84%;
		height: auto;
		top: 50%;
		right: 8%;
		z-index: 999;
		transform: translateY(-50%);
	}

	// 日历大小修改 --开始
	.ant-calendar-range {
		width: 400px !important;
		font-size: 12px !important;
	}

	.ant-calendar-cell {
		height: 24px !important;
		padding: 0 !important;
	}

	.ant-calendar-header {
		height: 35px !important;
		line-height: 35px !important;
	}

	// 日历大小修改--结束

	.ant-pro-basicLayout-content {
		margin: 24px 0 0 !important;
	}

	.table-center {
		:deep(.ant-table-thead > tr > th) {
			text-align: center !important;
			/* 表头居中 */
		}

		:deep(.ant-table-tbody > tr > td) {
			text-align: center !important;
			/* 单元格居中 */
		}
	}

	/// 设置表格文字大小
	.ant-table-thead>tr>th,
	.ant-table-tbody>tr>td {
		font-size: 12px !important;
	}
</style>